import React from "react";
import { IconButton, UploadingContainer } from "./file-upload.styled";
import { MdAttachFile } from "react-icons/md";
import { AiFillCloseCircle } from "react-icons/ai";
import ConfirmationModal from "../ConfirmationModal";

export const DocumentPreview = ({ file, onDelete, target = "" }: any) => {
  const [showBlockActivity, setShowBlockActivity] = React.useState(false);
  return (
    <>
      <UploadingContainer>
        <MdAttachFile className={"mr-12pt"} />
        <a
          className="card-title w-auto"
          href={file}
          target={target} //send target="_blank" to open in new tab
          //onClick={()=>window.open(EducrackAPI.asset.getAssetUrl(file))}
        >
          {file.split(".").pop()}
        </a>
        <IconButton onClick={() => setShowBlockActivity(true)}>
          <AiFillCloseCircle />
        </IconButton>
      </UploadingContainer>
      <ConfirmationModal
        open={showBlockActivity}
        onClose={() => {
          setShowBlockActivity(false);
        }}
        onConfirm={() => onDelete(file)}
        title="Are you sure?"
        description={`Deleted file can not be recovered`}
      />
    </>
  );
};
